import { jsx as _jsx } from "react/jsx-runtime";
import { ExportIcon } from '../assets';
import { ExportButtonWrapper } from './styles';
export const ExportButton = ({ handleClick }) => {
    return (_jsx(ExportButtonWrapper, { onClick: handleClick, children: _jsx(ExportIcon, {}) }));
};
//# sourceMappingURL=ExportButton.js.map